import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=513be743&scoped=true"
import script from "./NotificationPage.vue?vue&type=script&lang=js"
export * from "./NotificationPage.vue?vue&type=script&lang=js"
import style0 from "./NotificationPage.vue?vue&type=style&index=0&id=513be743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513be743",
  null
  
)

export default component.exports